import { render, staticRenderFns } from "./FileDropInput.vue?vue&type=template&id=2777c4c5"
import script from "./FileDropInput.vue?vue&type=script&lang=js"
export * from "./FileDropInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports